import axios from "axios";
import { API_BASE_PATH, API_ROUTES } from "../config";
import { toast } from "react-toastify";

export const http = () => {
  let instance;
  const userInfoFromStorage = localStorage.getItem("logininfo");
  if (userInfoFromStorage) {
    instance = axios.create({
      baseURL: API_BASE_PATH,
    });
  } else {
    instance = axios.create({
      baseURL: API_BASE_PATH,
    });
  }

  instance.interceptors.request.use(
    function (config) {
      const stored = localStorage.getItem("logininfo");
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          if (parsed && parsed.token) {
            config.headers = config.headers || {};
            config.headers.Authorization = parsed.token;
          }
        } catch (e) {
          // ignore parse errors
        }
      }
      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response;
    },
    function (error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      if (error.response) {
        const isLoginRequest =
          error.config?.url?.includes("/login") ||
          error.config?.url?.includes(API_ROUTES.login);
        const isLoginPage =
          typeof window !== "undefined" &&
          (window.location.pathname === "/login" ||
            window.location.pathname === "/");
        const hasLoginToken = !!localStorage.getItem("logininfo");

        if (error.response.status === 401) {
          if (!isLoginRequest && hasLoginToken) {
            localStorage.removeItem("logininfo");
            window.location.href = "/";
            return Promise.reject(error);
          }
        }
        if (error.response.status === 500) {
          toast.error(error.response.data?.error || "Server Error");
          throw new Error(error.response.data?.error || "Server Error");
        }
        
        // Extract server-provided error message if present
        let serverMessage = error.response.data?.message || error.response.data?.error || error.response.data?.errors;
        if (!serverMessage && error.response.status === 401) {
          serverMessage = "Invalid email or password";
        }
        if (serverMessage) {
          if (Array.isArray(serverMessage)) {
            serverMessage = serverMessage.join(", ");
          } else if (typeof serverMessage === "object") {
            serverMessage = Object.values(serverMessage).flat().join(", ");
          }
          error.message = serverMessage;
        }
      } else {
        // Network error or other issues without a response
        toast.error("Network Error: Unable to reach the server.");
      }

      return Promise.reject(error);
    }
  );

  return instance;
};
